<template>
  <div class="widget-rules">
    <v-card class="dashboard__card" height="100%">
      <v-card-title class="error white--text" style="word-break: initial;">
        Правила мотивационной программы
      </v-card-title>
      <v-card-text class="dashboard__card-text pt-3">
        <v-checkbox
          label="Согласие с правилами мотивационной программы"
          readonly
          v-model="checked"
          @click="dialogRules=true"></v-checkbox>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogRules" width="500" v-if="dialogRules && pageRules">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title v-html="pageRules.title"></v-card-title>
        <v-card-text v-html="pageRules.content"></v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogRules = false;">Отклонить</v-btn>
          <v-btn @click="dialogRules = false; ConfirmRules();">Принять</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['user'],
  data() {
    return {
      pageRules: null,
      dialogRules: false,
      checked: false,
    };
  },
  methods: {
    ConfirmRules() {
      const app = this;
      app.$store.getters.ax.post('/api/conditions/agreeing-rules', {
        profile_id: app.user.profile_id,
      })
        .then(() => {
          app.$store.dispatch('GetProfile');
        });
    },
  },
  mounted() {
    const app = this;
    this.$store.getters.axl.post('/profiles/api/v3/rules/list', {
      profile_id: app.user.profile_id,
    })
      .then(({ data }) => {
        this.pageRules = data.pageRules;
      })
      .catch((err) => {
        console.warn(err);
      });
  },
};
</script>

<style lang="scss"></style>
